import { library, dom } from '@fortawesome/fontawesome-svg-core'
import * as brands from './font-awesome-brands'
import * as solid from './font-awesome-solids'

library.add(brands, solid)
dom.watch()